import {getField, updateField} from 'vuex-map-fields';
import * as API from '@/api';
import router from '@/router';
import {EventBus} from '@/event-bus.js';
import DEFINES from '@/defines';
import { isDateTimePast } from "@/helpers";


// ==================== STATE =====================

function initialState () {
  return {
    todayList: [],
    upcomingList: [],
    ongoingList: [],
    vodList:[],
    archiveList: [],
    currentSubtitle: 'off',
  };
}
const state = initialState ();

// ==================== ACTIONS =====================

const actions = {
  async todayList (context, payload) {
    var response = await API.screening.todayList (payload);

    context.commit ('set_today_list', {
      screeners: response.screeners,
    });
    return response;
  },
  async upcomingList (context, payload) {
    var response = await API.screening.upcomingList (payload);

    context.commit ('set_upcoming_list', {
      screeners: response.screeners,
    });
    return response;
  },
  async ongoingList (context, payload) {
    var response = await API.screening.ongoingList (payload);

    context.commit ('set_ongoing_list', {
      screeners: response.screeners,
    });
    return response;
  },

  async listVodEvents (context, payload) {
    var response = await API.screening.listVodEvents (payload);

    context.commit ('set_vod_list', {
      screeners: response.screeners,
    });
    return response;
  },

  async archiveList (context, payload) {
    var response = await API.screening.archiveList (payload);

    context.commit ('set_archive_list', {
      screeners: response.screeners,
    });
    return response;
  },

  async getStreamUrl (context, payload) {
    var response = await API.screening.getStreamUrl (payload);
    return response;
  },

  async reset (context, payload) {
    context.commit ('reset');
  },

  async getAndEnforce (context, payload) {
    // console.log ('Getting from API with enforce');
    var response = await API.screening.getAndEnforce (payload);
    return response;
  },

  async getWithoutEnforce (context, payload) {
    // console.log ('Getting from API without enforce');
    var response = await API.screening.getWithoutEnforce (payload);
    return response;
  },

  async get (context, payload) {
    var response = await API.screening.get (payload);
    return response;
  },

  async interactiveStreamsChanged (context, payload) {
    EventBus.$emit ('showStreamAddedNotification', payload);
    EventBus.$emit ('interactiveStreamsChanged', payload);
  },

  async interactiveStreamRemoved (context, payload) {
    EventBus.$emit ('showStreamRemovedNotification', payload);
    EventBus.$emit ('interactiveStreamRemoved', payload);
  },

  async showStreamRemovedNotification (context, payload) {
    EventBus.$emit ('showStreamRemovedNotification', payload);
  },

  async markFirstWatch(context, payload) {
    var response = await API.screening.markFirstWatch(payload);
    return response;
  },

  /**
   * Get physical events seats status
   */
  async getSeatsStatus(context, payload) {
    var response = await API.screening.getSeatsStatus(payload);
    return response;
  },

   /**
   * Get external url
   */
    async getExternalSrcUrl(context, payload) {
      var response = await API.screening.getExternalSrcUrl(payload);
      return response;
    },

    async getGeoGraphicalCatalogue(context, payload) {
      return await API.screening.getGeoGraphicalCatalogue(payload);
    }
};

// ==================== GETTERS =====================

const getters = {
  getField,
  getTodayScreenings: state => {
    return state.todayList;
  },
  getUpcomingScreenings: state => {
    return state.upcomingList;
  },
  getOngoingScreenings: state => {
    var screenings = {};
    screenings.data =[];
    if(state.ongoingList.data){
      screenings.data = state.ongoingList.data.filter (screening => {
        return !isDateTimePast(screening.screening_ends_at);
      });
    }
    return screenings;
  },
  isScreeningPaid: state => screening => {
    if (!screening) {
      return false;
    }
    return screening.monetization && screening.monetization_enabled;
  },
  isScreeningSeatsAvailable: state => screening => {
    if (!screening) {
      return false;
    }
  
    const totalRegistrants = Number(screening.total_registrants);
    const seatLimit = Number(screening.limitation);
    
    if (seatLimit) {
      // Return true if seats are available, false otherwise
      return totalRegistrants < seatLimit;
    }else{
      return false; // If no seat limit is set, assume seats are available
    }
  },
  isSinglePricingAvailableOnScreening: state => screening => {
    return screening.monetization.hasOwnProperty (
      DEFINES.MONETIZATION.PRICING_TYPE.SINGLE_PURCHASE
    );
  },
  isGroupPricingAvailableOnScreening: state => screening => {
    return screening.monetization.hasOwnProperty (
      DEFINES.MONETIZATION.PRICING_TYPE.GROUP_PURCHASE
    );
  },
  isVodPricingAvailableOnScreening: state => screening => {
    return screening.monetization.hasOwnProperty (
      DEFINES.MONETIZATION.PRICING_TYPE.VOD_PURCHASE
    );
  },
};

// ==================== MUTATIONS =====================

const mutations = {
  updateField,
  set_today_list (state, payload) {
    state.todayList = payload.screeners;
  },
  set_upcoming_list (state, payload) {
    state.upcomingList = payload.screeners;
  },
  set_ongoing_list (state, payload) {
    state.ongoingList = payload.screeners;
  },
  set_vod_list (state, payload) {
    state.vodList = payload.screeners;
  },
  set_archive_list (state, payload){
    state.archiveList = payload.screeners;
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      if (key != 'currentSubtitle') {
        state[key] = s[key];
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
